$shm_hitalama_map_widget_float_tabulator $shm_hitalama_map_widget_float
	controls /
		<= Tabulator $shm_hitalama_tabulator
			columns <= columns /
			data <= data /
			options <= options null
	width_min 240
	height_min 160
	contextmenu_body /
		<= Echarts_add $mol_button_minor
			title \Добавить ECharts
			click? <=> echarts_add? null
		<= Settings_add $mol_button_minor
			title \Добавить виджет настроек
			click? <=> settings_add? null
		^
